var map = {
	"./mt4-small.png": 26421,
	"./mt5-small.png": 55359,
	"./natwest-logo.jpg": 49416,
	"./pamm-logo.jpg": 9603,
	"./pamm-small.png": 35799,
	"./social-facebook.svg": 88074,
	"./social-gplus.svg": 45089,
	"./social-linkedin.svg": 4346,
	"./social-twitter.svg": 74938,
	"./xstation-logo.jpg": 74541,
	"./xstation-small.png": 64785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32690;